import { render, staticRenderFns } from "./CiPublicationRow.vue?vue&type=template&id=2b468427&"
import script from "./CiPublicationRow.vue?vue&type=script&lang=js&"
export * from "./CiPublicationRow.vue?vue&type=script&lang=js&"
import style0 from "./CiPublicationRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports